import ViewportWatcherPackage from '@aveneo/frontmoon-viewport-watcher/lib/components';

import withViewport from '@aveneo/frontmoon-viewport-watcher/lib/hocs/withViewport';

import OrderModule from 'src/modules/Order';

import withScreenHeightDetector from 'src/hocs/withScreenHeightDetector';

const dependencies = (di, store) => ({
    modules: [{
        moduleName: OrderModule.moduleName,
        module: {
            WebSockets: OrderModule.WebSockets
        }
    }],
    components: [
        () => ({
            store: { dependency: store, method: 'constant' },
            withViewport
        }),
        ViewportWatcherPackage,
        ({ components }) => ({
            ViewportWatcher: withScreenHeightDetector(components.ViewportWatcher)
        })
    ]
});

export default dependencies;
